import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chart-loader',
  templateUrl: './chart-loader.component.html',
  styleUrls: ['./chart-loader.component.css']
})
export class ChartLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
